import axios from "axios";
import { store } from "../store"; // import your store
import { API_BASE_URL } from "@/config/env";
import {
  applyPendingQuestionnaireState,
} from "@/utils/fundingQuestionnaireGuard";

const theCookie = document.cookie

  .split(";")
  .map((coki) => coki.split("="))
  .reduce(
    (acc, [key, val]) => ({
      ...acc,
      [key.trim()]: decodeURIComponent(val),
    }),
    {}
  )["wsataJwt"];
let isAuthAdmin = "false";
let authAdminId = "";

if (
  theCookie !== undefined &&
  localStorage["role"] &&
  localStorage["role"] == "7"
) {
  isAuthAdmin = "true";
  authAdminId = JSON.parse(theCookie).agent_id;
}

let token = "";
if (theCookie !== undefined) {
  token = JSON.parse(theCookie).token;
}

export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "x-api-key":
      "WFKvB4Vjr8v5BVmxY7CDQ6ZMAU8DSHSBFKCMVpkfd5hhZyKTvnV3uh5XwxSwhnfeUbptZ7Z4XFJCR4vKXeHWGHTZ6djsYXjdAatf",
    // Authorization: `Bearer ${token}`,
    appplatform: "vue",
    auth_admin: isAuthAdmin,
    auth_admin_id: authAdminId,
  },
});

// Add an interceptor to set the Authorization header dynamically
axiosInstance.interceptors.request.use((config) => {
  store.dispatch("showLoader");
  const theCookie = document.cookie
    .split(";")
    .map((cookie) => cookie.split("="))
    .reduce(
      (acc, [key, val]) => ({
        ...acc,
        [key.trim()]: decodeURIComponent(val),
      }),
      {}
    )["wsataJwt"];

  let token = "";

  if (theCookie !== undefined) {
    const cookieData = JSON.parse(theCookie);
    if (cookieData.token) {
      token = cookieData.token;
    }
  }

  // Set the Authorization header only if the token is available
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});
axiosInstance.interceptors.response.use(
  (response) => {
    store.dispatch("hideLoader");
    return response;
  },
  (error) => {
    store.dispatch("hideLoader");

    const requiresQuestionnaire =
      error?.response?.status === 403 &&
      error?.response?.data?.payload?.requires_questionnaire;

    if (requiresQuestionnaire && localStorage.getItem("role") === "2") {
      const pendingCount = error.response.data.payload.pending_count || 1;
      applyPendingQuestionnaireState({ id: true, pending_count: pendingCount });
      store.state.showFundingQuestionnaireRequiredAlert = true;
      import("@/routes").then(({ default: appRouter }) => {
        appRouter.push({
          name: "FundingQuestionAndAnswer",
          query: { required: "1" },
        });
      });
    }

    return Promise.reject(error);
  }
);

// Usage example:
// axiosInstance.get('/your-api-endpoint')
